import * as React from "react";
import { Outlet } from 'react-router-dom';
import user from 'src/components/User';
import PermissionComponent from 'src/components/Permissions/Permission';
import i18n from "i18next";
import Sidebar from 'src/components/Sidebar';
import getMenu from './menu';
import { Container } from 'rsuite';
import classNames from 'classnames';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const AdminRootPage = _ref => { let {} = _ref; const [expanded, setExpanded] = React.useState(window.innerWidth > 768); const containerClasses = classNames('page-container', { 'container-full': !expanded }); return /*#__PURE__*/ _jsxs(PermissionComponent, { userPermission: user.permissions, permission: ["system", "admin"], children: [/*#__PURE__*/ _jsx(Sidebar, { header: i18n.t('project.label'), menuList: getMenu(), expanded: expanded, setExpanded: setExpanded }, 'sidebar'), /*#__PURE__*/ _jsx(Container, { className: containerClasses, children: /*#__PURE__*/ _jsx(Outlet, {}) })] }); };
export default AdminRootPage;
